/* tslint:disable */
/* eslint-disable */
/**
 * BloomRegistration.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewClassSessionEnrollmentDto
 */
export interface NewClassSessionEnrollmentDto {
    /**
     * 
     * @type {string}
     * @memberof NewClassSessionEnrollmentDto
     */
    classSessionId?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewClassSessionEnrollmentDto
     */
    studentIds?: Array<string> | null;
}

export function NewClassSessionEnrollmentDtoFromJSON(json: any): NewClassSessionEnrollmentDto {
    return NewClassSessionEnrollmentDtoFromJSONTyped(json, false);
}

export function NewClassSessionEnrollmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewClassSessionEnrollmentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classSessionId': !exists(json, 'classSessionId') ? undefined : json['classSessionId'],
        'studentIds': !exists(json, 'studentIds') ? undefined : json['studentIds'],
    };
}

export function NewClassSessionEnrollmentDtoToJSON(value?: NewClassSessionEnrollmentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classSessionId': value.classSessionId,
        'studentIds': value.studentIds,
    };
}

